"use client";
import { jsxs as s, jsx as n } from "react/jsx-runtime";
import { LAYERS as c } from "../../constants/layers.js";
import { square as f } from "../../styles/mixins/square.js";
import { css as d } from "@emotion/react";
import i from "@emotion/styled";
import { COLORS as m } from "../../../tokens/colors/Colors.js";
import { FONT_SIZES as b } from "../../../tokens/font-sizes/FontSizes.js";
import { SIZES as p } from "../../../tokens/sizes/Sizes.js";
import { SPACINGS as t } from "../../../tokens/spacings/Spacings.js";
import { forwardRef as x } from "react";
const $ = x(
  ({ children: r, feType: o, ...a }, e) => {
    const l = ["popup", "tooltip"].includes(o);
    return /* @__PURE__ */ s(g, { ...a, "data-comp": o, feType: o, ref: e, children: [
      l && /* @__PURE__ */ n(v, { "data-popper-arrow": !0 }),
      /* @__PURE__ */ n(h, { children: r })
    ] });
  }
);
$.displayName = "Popover";
const g = i.div(
  ({
    feDark: r,
    feMaxWidth: o,
    feNoPadding: a,
    feType: e
  }) => d`
		background-color: ${r ? m.gray700 : m.white};
		border-radius: ${p.s02};
		box-shadow:
			0 1px 1px 0 rgba(39 51 66 / 10%),
			0 1px 6px 0 rgba(39 51 66 / 10%),
			0 0 10px 0 rgba(39 51 66 / 12%);
		color: ${r && m.white};
		max-width: ${o};
		pointer-events: ${e === "tooltip" && "none"};
		z-index: ${c.popover};

		${e !== "dropdown" && d`
			font-size: ${b.xs};
			padding: ${!a && `${t.xs} ${t.sm}`};
		`}

		${e === "dropdown" && d`
			padding-block: ${t.xxs};
		`}

		&[data-popper-placement^='right'] {
			filter: drop-shadow(-1px 0 1px rgba(39 51 66 / 30%));
		}

		&[data-popper-placement^='left'] {
			filter: drop-shadow(1px 0 1px rgba(39 51 66 / 30%));
		}

		&[data-popper-placement^='top'] {
			filter: drop-shadow(0 1px 1px rgba(39 51 66 / 30%));
		}

		&[data-popper-placement^='bottom'] {
			filter: drop-shadow(0 -1px 1px rgba(39 51 66 / 30%));
		}
	`
), h = i.div`
	position: relative;
`, v = i.div`
	visibility: hidden;

	&,
	&::before {
		${f(p.s08)};
		background-color: inherit;
		position: absolute;
	}

	&::before {
		content: '';
		transform: rotate(45deg);
		visibility: visible;
	}

	[data-popper-placement='left'] &,
	[data-popper-placement='right'] & {
		top: 50%;
		transform: translateY(-50%);
	}

	[data-popper-placement='bottom'] &,
	[data-popper-placement='top'] & {
		left: 50%;
		transform: translateX(-50%);
	}

	[data-popper-placement^='top'] & {
		bottom: -${p.s04};
	}

	[data-popper-placement='bottom-end'] &,
	[data-popper-placement='top-end'] & {
		right: ${t.sm};
	}

	[data-popper-placement='bottom-start'] &,
	[data-popper-placement='top-start'] & {
		left: ${t.sm};
	}

	[data-popper-placement^='bottom'] & {
		top: -${p.s04};
	}

	[data-popper-placement^='left'] & {
		right: -${p.s04};
	}

	[data-popper-placement^='right'] & {
		left: -${p.s04};
	}

	[data-popper-placement='left-end'] &,
	[data-popper-placement='right-end'] & {
		bottom: ${t.sm};
	}

	[data-popper-placement='left-start'] &,
	[data-popper-placement='right-start'] & {
		top: ${t.sm};
	}
`;
export {
  $ as default
};
